export type UsoCFDIType =
  "G01" |
  "G02" |
  "G03" |
  "I01" |
  "I02" |
  "I03" |
  "I04" |
  "I05" |
  "I06" |
  "I07" |
  "I08" |
  "D01" |
  "D02" |
  "D03" |
  "D04" |
  "D05" |
  "D06" |
  "D07" |
  "D08" |
  "D09" |
  "D10" |
  "S01" |
  "CP01" |
  "CN01";
  
const UsoCFDIEnum = {
  "G01": "Adquisición de mercancías.",
  "G02": "Devoluciones, descuentos o bonificaciones.",
  "G03": "Gastos en general.",
  "I01": "Construcciones.",
  "I02": "Mobiliario y equipo de oficina por inversiones.",
  "I03": "Equipo de transporte.",
  "I04": "Equipo de computo y accesorios.",
  "I05": "Dados, troqueles, moldes, matrices y herramental.",
  "I06": "Comunicaciones telefónicas.",
  "I07": "Comunicaciones satelitales.",
  "I08": "Otra maquinaria y equipo.",
  "D01": "Honorarios médicos, dentales y gastos hospitalarios.",
  "D02": "Gastos médicos por incapacidad o discapacidad.",
  "D03": "Gastos funerales.",
  "D04": "Donativos.",
  "D05": "Intereses reales efectivamente pagados por créditos hipotecarios(casa habitación).",
  "D06": "Aportaciones voluntarias al SAR.",
  "D07": "Primas por seguros de gastos médicos.",
  "D08": "Gastos de transportación escolar obligatoria.",
  "D09": "Depósitos en cuentas para el ahorro, primas que tengan como base planes de pensiones.",
  "D10": "Pagos por servicios educativos(colegiaturas).",
  "S01": "Sin efectos fiscales.",
  "CP01": " Pagos",
  "CN01": " Nómina"
};

Object.freeze(UsoCFDIEnum);

export default UsoCFDIEnum;